module.exports = __webpack_public_path__ + "static/media/next-button.4d7bcc6f.svg";